import superagent from "superagent";
import Cookies from "universal-cookie";
import { IS_LOADING, THROW_ERROR, THROW_SUCCESS } from "../../store/constants";
import { base_url } from "../../utils/constants";
import { getRequest } from "../../utils/request";
import { GET_ACCOUNT_DATA, PAYMENT_HISTORY,  GET_HOW_IT_WORKS_CMS_DATA, GET_IS_PRO_MEMBER, INITIAL_LOADER } from "./constants";

const cookie = new Cookies();

export const getAccountInformation = (data) => (dispatch) => {
  const arrayOfCallbacks = [
    (payload) => {
      dispatch({ type: INITIAL_LOADER, payload: payload });
    },
  ];
  getRequest("user", data, dispatch, GET_ACCOUNT_DATA, null, null, arrayOfCallbacks);
};
export const getPaymentHistory = (pagination) => (dispatch) => {
  getRequest(`transactions${pagination}`, null, dispatch, PAYMENT_HISTORY);
};


export const getHowItWorksDetails = (data) => (dispatch) => {
  getRequest("howitworks-cms", data, dispatch, GET_HOW_IT_WORKS_CMS_DATA);
};
export const getIsProMember = (id) => (dispatch) => {
  return superagent
    .get(`${base_url}get-is-pro-user/${id}`)
    .set("accept", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .end((_err, res) => {
      if (res?.text) {
        dispatch({ type: GET_IS_PRO_MEMBER, payload: res.text });
      }
    });
};